import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import store from './../store'
import LoginView from '@/components/LoginView.vue'
import HomeView from '@/views/HomeView.vue'
import ProfileView from '@/views/ProfileView.vue'
import AchievementsView from '@/views/realisations/AchievementsView.vue'
import IndexMission from '@/views/missions/IndexMission.vue'
import IndexRealisation from '@/views/realisations/IndexRealisation.vue'


const routes: Array<RouteRecordRaw> = [
  {
    path: '/se-connecter',
    name: 'login',
    component: LoginView
  },
  {
    path: '/',
    name: 'accueil',
    component: HomeView,
  },
  {
    path: '/profil',
    name: 'profile',
    component: ProfileView
  },
  {
    path: '/realisations',
    name: 'achievements',
    component: IndexRealisation
  },
  {
    path: '/missions',
    name: 'missions',
    component: IndexMission
  },
  {
    path: '/factures',
    name: 'factures',
    component: AchievementsView
  },
  {
    path: '/messages',
    name: 'messages',
    component: AchievementsView
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routes
})

router.beforeEach((to, from, next) => {
  if (to.name !== 'login' && !store.state.authenticated) next({ name: 'login' })
  next()
})

export default router